import assign = require('object-assign');
import {
    FETCH_STATE_REQUEST, FETCH_STATE_SUCCESS, FETCH_STATE_FAILURE,
    FETCH_NODES_WITH_STATES_REQUEST, FETCH_NODES_WITH_STATES_SUCCESS, FETCH_NODES_WITH_STATES_FAILURE,
} from '../../constants/Node';

import { IWidgetDataState } from '../../interfaces/states';

const initialState = {};

export function isResponsible(action) {
    switch (action.type) {
        case FETCH_STATE_REQUEST:
        case FETCH_STATE_SUCCESS:
        case FETCH_STATE_FAILURE:
        case FETCH_NODES_WITH_STATES_REQUEST:
        case FETCH_NODES_WITH_STATES_SUCCESS:
        case FETCH_NODES_WITH_STATES_FAILURE:
            return true;
        default:
            return false;
    }
}

function formatDate(state, key) {
    if (state[key]) {
        state[key] = new Date(state[key]);
    }
    return state;
}

function formatHint(hint) {
    formatDate(hint, 'date');
    return hint;
}

function formatState(state) {
    formatDate(state, 'date');
    formatDate(state, 'lastDate');

    if(state.hints) {
        state.hints.forEach(formatHint);
    }

    return state;
}

function formatStates(states) {
    if(Array.isArray(states)) {
        states.forEach(formatState);
        return states;
    }

    Object.keys(states).forEach(key => {
        states[key].forEach(formatState);
    });

    return states;
}

export default function states(state = initialState, action): IWidgetDataState {
    switch (action.type) {
        case FETCH_NODES_WITH_STATES_REQUEST:
        case FETCH_STATE_REQUEST: {
            return assign({}, state, {
                states: {
                    loading: true
                }
            });
        }
        case FETCH_NODES_WITH_STATES_SUCCESS: {
            return assign({}, state, {
                states: {
                    loading: false,
                    data: formatStates(action.payload.states)
                }
            });
        }
        case FETCH_STATE_SUCCESS: {
            return assign({}, state, {
                states: {
                    loading: false,
                    data: formatStates(action.payload)
                }
            });
        }
        case FETCH_NODES_WITH_STATES_FAILURE:
        case FETCH_STATE_FAILURE: {
            return assign({}, state, {
                states: {
                    loading: false,
                    error: action.error,
                    data: action.payload
                }
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/widgetData/states.ts